import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
<th parentName="tr" {...{
            "align": null
          }}></th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Field`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Details`}</strong></td>
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Example`}</strong></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-link"><strong parentName="td">{`For Australian Accounts`}</strong></div></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`Regulated`}</em></strong></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` Type - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Type of SuperFund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Accepted values: REGULATED`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Employee/member number`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Unique Member number for the super fund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`98001`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` Fund name - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Superannuation fund name`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Vanguard Superfund`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` Super Fund ID (USI) - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Unique Superannuation Identifier for the fund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Super fund test`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` ABN - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Valid Australian Business Number of the fund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`65714394898`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`SMSF`}</em></strong></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` Type - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Type of SuperFund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Accepted values: SMSF`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Employee/member number`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Unique Member number for the super fund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`98002`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` Fund name - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Superannuation fund name`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`SMSF Family fund`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Electronic Service Address`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Electronic Service Address for data messages`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`ESUPERFUND`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{` ABN - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Valid Australian Business Number of the fund`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`88714394999`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{`Bank Account Name - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Bank Account name for SMSF`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`SMSF Fund name`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{`Bank Account BSB - Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`BSB for SMSF`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`016 789`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{`Bank Account Number – Mandatory `}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`Bank Account number for SMSF`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`654587787`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-link"><strong parentName="td">{`For New Zealand Accounts`}</strong></div></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-danger">{`Status - Mandatory`}</div></td>
<td parentName="tr" {...{
            "align": null
          }}>{`The KiwiSaver status`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Accepted values - ACTIVE, OPT_OUT,`}<br />{`SAVINGS_SUSPENSION, NOT_A_MEMBER`}<br />{`TEMPORARY_RATE_REDUCTION, `}<br />{`NOT_ELIGIBLE`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Employer Contribution Percentage`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`KiwiSaver contribution made by the employer`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`4%`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Employee Contribution Percentage`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`KiwiSaver contribution made by the employee`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`3.5% (allowed values 3, 3.5, 4, 6, 8, 10)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`ESCT`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Employer Contribution tax based on earnings`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`17.5% (allowed values: 10.5, 17.5, 30, 33)`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-link"><strong parentName="td">{`When KiwiSaver status is OPT_OUT`}</strong></div></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Opt Out Date`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Opt out Date`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`2022-10-29`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Bank Account Number`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Bank account number when chosen to opt out`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`231235435345`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Account holder's Name`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Name of the bank account holder when chosen to opt out`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Suresh Rana`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-link"><strong parentName="td">{`When KiwiSaver status is SAVINGS_SUSPENSION`}</strong></div></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Suspension End Date`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Date when the KiwiSaver to be suspended`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`2023-09-23`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}><div className="text-link"><strong parentName="td">{`When KiwiSaver status is TEMPORARY_RATE_REDUCTION`}</strong></div></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
<td parentName="tr" {...{
            "align": null
          }}></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`Rate Reduction End Date`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Date when the KiwiSaver rate reduction to be ended`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`2026-04-01`}</td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      